import { c as _c } from "react/compiler-runtime";
import { ProductTypeEnum } from '@systemeio/digital-store-shared';
import { BreadcrumbsData } from '@systemeio/ui';
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
const StoreBreadcrumbs = () => {
  const $ = _c(38);
  const {
    t
  } = useLocoTranslation();
  const {
    storeId,
    itemId,
    tab,
    baseStoreHref,
    BASE_HREF,
    productType
  } = useStoreQuery();
  const {
    data: store
  } = useStore(storeId);
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.stores.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== BASE_HREF || $[3] !== t0) {
    t1 = {
      caption: t0,
      href: BASE_HREF,
      isStatic: true
    };
    $[2] = BASE_HREF;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = store?.name || "";
  let t3;
  if ($[5] !== baseStoreHref || $[6] !== t2) {
    t3 = {
      caption: t2,
      href: baseStoreHref
    };
    $[5] = baseStoreHref;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let breadcrumbsData;
  if ($[8] !== baseStoreHref || $[9] !== itemId || $[10] !== productType || $[11] !== t || $[12] !== t1 || $[13] !== t3 || $[14] !== tab) {
    breadcrumbsData = [t1, t3];
    let href = `${baseStoreHref}`;
    if (tab) {
      href = href + `?tab=${tab}`;
      let caption = "";
      bb0: switch (tab) {
        case StoreTabEnum.profile:
          {
            let t4;
            if ($[16] !== t) {
              t4 = t("dashboard.store.profile.title");
              $[16] = t;
              $[17] = t4;
            } else {
              t4 = $[17];
            }
            caption = t4;
            break bb0;
          }
        case StoreTabEnum.link:
          {
            let t4;
            if ($[18] !== t) {
              t4 = t("dashboard.store.link.title");
              $[18] = t;
              $[19] = t4;
            } else {
              t4 = $[19];
            }
            caption = t4;
            break bb0;
          }
        case StoreTabEnum.optin:
          {
            let t4;
            if ($[20] !== t) {
              t4 = t("dashboard.store.optin.title");
              $[20] = t;
              $[21] = t4;
            } else {
              t4 = $[21];
            }
            caption = t4;
            break bb0;
          }
        case StoreTabEnum.theme:
          {
            let t4;
            if ($[22] !== t) {
              t4 = t("dashboard.store.theme.title");
              $[22] = t;
              $[23] = t4;
            } else {
              t4 = $[23];
            }
            caption = t4;
            break bb0;
          }
        case StoreTabEnum.storeSettings:
          {
            let t4;
            if ($[24] !== t) {
              t4 = t("dashboard.store.edit.title");
              $[24] = t;
              $[25] = t4;
            } else {
              t4 = $[25];
            }
            caption = t4;
            break bb0;
          }
        case StoreTabEnum.product:
          {
            bb1: switch (productType) {
              case ProductTypeEnum.download:
                {
                  let t4;
                  if ($[26] !== t) {
                    t4 = t("dashboard.store.product.download.title");
                    $[26] = t;
                    $[27] = t4;
                  } else {
                    t4 = $[27];
                  }
                  caption = t4;
                  break bb1;
                }
              case ProductTypeEnum.eCourse:
                {
                  let t4;
                  if ($[28] !== t) {
                    t4 = t("dashboard.store.product.e_course.title");
                    $[28] = t;
                    $[29] = t4;
                  } else {
                    t4 = $[29];
                  }
                  caption = t4;
                  break bb1;
                }
              case ProductTypeEnum.physicalProduct:
                {
                  let t4;
                  if ($[30] !== t) {
                    t4 = t("dashboard.store.product.physical_product.title");
                    $[30] = t;
                    $[31] = t4;
                  } else {
                    t4 = $[31];
                  }
                  caption = t4;
                }
            }
          }
      }
      if (itemId) {
        href = href + `&item=${itemId}`;
      }
      if (productType) {
        href = href + `&productType=${productType}`;
      }
      let t4;
      if ($[32] !== caption || $[33] !== href) {
        t4 = {
          caption,
          href,
          isStatic: true
        };
        $[32] = caption;
        $[33] = href;
        $[34] = t4;
      } else {
        t4 = $[34];
      }
      breadcrumbsData.push(t4);
    }
    $[8] = baseStoreHref;
    $[9] = itemId;
    $[10] = productType;
    $[11] = t;
    $[12] = t1;
    $[13] = t3;
    $[14] = tab;
    $[15] = breadcrumbsData;
  } else {
    breadcrumbsData = $[15];
  }
  const t4 = !store;
  let t5;
  if ($[35] !== breadcrumbsData || $[36] !== t4) {
    t5 = <BreadcrumbsDashboard isFetching={t4} data={breadcrumbsData} />;
    $[35] = breadcrumbsData;
    $[36] = t4;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  return t5;
};
export default StoreBreadcrumbs;